import { render, staticRenderFns } from "./pwdVerify.vue?vue&type=template&id=38f06562&scoped=true&"
import script from "./pwdVerify.vue?vue&type=script&lang=js&"
export * from "./pwdVerify.vue?vue&type=script&lang=js&"
import style0 from "./pwdVerify.vue?vue&type=style&index=0&id=38f06562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f06562",
  null
  
)

export default component.exports